<template>
  <div>
    <v-card flat class="textLight--text rounded-lg">
      <ValidationObserver ref="observer">
        <v-row class="pa-5">
          <v-col cols="12">
            <v-row align="center">
              <v-col cols="4"
                ><div>
                  <p class="ma-0 text-start font-weight-thin">
                    {{ $t("organization.organizationName") }}
                  </p>
                </div></v-col
              >
              <v-col cols="8" @click="error = null">
                <LocalisedContentEditable
                  :values="name"
                  @update:values="values => (this.name = values)"
                  :editable="true"
                  :textAreaDense="true"
                  css-class="text-h4 font-weight-bold textLight--text"
                  :showLanguageTabs="true"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row align="center">
              <v-col cols="4"
                ><div>
                  <p class="ma-0 text-start font-weight-thin">
                    {{ $t("organization.logo") }}
                  </p>
                </div></v-col
              >
              <v-col cols="8" @click="error = null">
                <image-uploader
                  id="training-image"
                  :maxWidth="1024"
                  :maxHeight="1024"
                  :quality="0.9"
                  :autoRotate="true"
                  outputFormat="blob"
                  :preview="false"
                  :capture="false"
                  accept="image/*"
                  doNotResize="['gif', 'svg']"
                  @input="onFileSelect"
                >
                  <label for="training-image" slot="upload-label">
                    <!--training image new-->
                    <v-container
                      v-if="organizationImageUrl"
                      fluid
                      class="pa-0"
                      style="position: relative"
                    >
                      <v-img
                        :src="organizationImageUrl"
                        alt="Image"
                        :max-height="organizationImageHeight"
                        cover
                        style="border-radius: 7px"
                        contain
                      />

                      <div style="position: absolute; bottom: 5px; right: 5px">
                        <v-btn
                          small
                          color="error"
                          min-width="80"
                          class="rounded-1"
                          @click.prevent="cancelMediaSelection"
                        >
                          {{ $t("course.courseDetails.cancel") }}
                        </v-btn>
                      </div>
                    </v-container>

                    <!--training image empty-->
                    <v-container
                      v-else
                      fluid
                      class="fill-height justify-center pa-0"
                      style="
                        border-style: dashed;
                        border-radius: 7px;
                        border-width: 3px;
                        opacity: 0.5;
                      "
                      :style="`height: ${organizationImageHeight}px`"
                    >
                      <div
                        class="textLight--text text-capitalize hand-cursor"
                        style="opacity: 0.5"
                      >
                        <v-icon size="40">mdi-plus</v-icon>
                        <div>
                          {{ $t("organization.uploadImage") }}
                        </div>
                      </div>
                    </v-container>
                  </label>
                </image-uploader>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row align="center">
              <v-col cols="4"
                ><div>
                  <p class="ma-0 text-start font-weight-thin">
                    {{ $t("organization.about") }}
                  </p>
                </div></v-col
              >
              <v-col cols="8" @click="error = null">
                <LocalisedContentEditable
                  :values="description"
                  @update:values="values => (this.description = values)"
                  :editable="true"
                  :text-area-rows="5"
                  css-class="text-h4 font-weight-bold textLight--text"
                  :showLanguageTabs="true"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row align="center">
              <v-col cols="4"
                ><div>
                  <p class="ma-0 text-start font-weight-thin">
                    {{ $t("user.email") }}
                  </p>
                </div></v-col
              >
              <v-col cols="8">
                <validation-provider v-slot="{ errors }" rules="email">
                  <v-text-field
                    :error-messages="errors"
                    @click="error = null"
                    v-model="email"
                    class="rounded-lg"
                    dense
                    hide-details="auto"
                    outlined
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row align="center">
              <v-col cols="4"
                ><div>
                  <p class="ma-0 text-start font-weight-thin">
                    {{ $t("user.phone") }}
                  </p>
                </div></v-col
              >
              <v-col cols="8">
                <validation-provider v-slot="{ errors }" rules="numeric|max:10">
                  <v-text-field
                    :error-messages="errors"
                    @click="error = null"
                    v-model="phone"
                    class="rounded-lg"
                    dense
                    hide-details="auto"
                    outlined
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row align="center">
              <v-col cols="4"
                ><div>
                  <p class="ma-0 text-start font-weight-thin">
                    {{ $t("organization.contactName") }}
                  </p>
                </div></v-col
              >
              <v-col cols="8">
                <v-text-field
                  @click="error = null"
                  v-model="contactName"
                  class="rounded-lg"
                  dense
                  hide-details
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row align="center">
              <v-col cols="12">
                <v-btn
                  :loading="btnLoading"
                  depressed
                  :disabled="btnDisable"
                  block
                  color="primary"
                  style="text-transform: unset"
                  class="rounded-lg font-weight-normal"
                  @click="add"
                >
                  {{ $t("organization.add") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" v-if="error">
            <p class="pa-0 ma-0 error--text">
              {{ error }}
            </p>
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-card>
  </div>
</template>
<script>
import LocalisedContentEditable from "@/app/core-module/components/LocalisedContentEditable";
import { createOrUpdateOrganization } from "../methods/createOrUpdateOrganization";
import "../../core-module/util/validationRules";

export default {
  data() {
    return {
      organizationImage: null,
      organizationImageUrl: null,
      name: null,
      description: null,
      email: null,
      phone: null,
      contactName: null,
      btnDisable: true,
      btnLoading: false,
      error: null,
    };
  },
  components: {
    LocalisedContentEditable,
  },
  watch: {
    name: {
      immediate: false,
      handler() {
        this.btnDisable = this.isValid(this.name) ? false : true;
      },
    },

    // organizationImageUrl() {
    //   this.btnDisable = !this.isValid();
    // },
  },
  computed: {
    organizationImageHeight() {
      return this.$vuetify.breakpoint.xlOnly
        ? 400
        : this.$vuetify.breakpoint.lgAndUp
        ? 150
        : 250;
    },
  },
  methods: {
    onFileSelect(output) {
      var reader = new FileReader();
      reader.readAsDataURL(output);
      var self = this;

      reader.onloadend = function () {
        var base64data = reader.result;
        // self.categoryInput.url = base64data;
        self.organizationImageUrl = base64data;
      };
      this.organizationImage = output;
    },
    cancelMediaSelection() {
      this.organizationImage = null;
      this.organizationImageUrl = null;
      const el = document.getElementById("training-image");
      if (el) el.value = "";
    },
    isValid(val) {
      return this.filterEmptyLocalisedValues(val).length ? true : false;
    },
    async add() {
      const isValidForm = await this.$refs.observer.validate();

      if (isValidForm) {
        this.btnLoading = true;
        await createOrUpdateOrganization({
          name: this.filterEmptyLocalisedValues(this.name),
          description: this.filterEmptyLocalisedValues(this.description),
          email: this.email ? this.email : null,
          phone: this.phone ? this.phone : null,
          contactName: this.contactName ? this.contactName : null,
          logo:
            this.organizationImage instanceof Blob
              ? this.organizationImage
              : null,
        }).then(response => {
          this.btnLoading = false;
          if (response.data) {
            this.$emit("onOrganizationCreate", response?.data?._id);
          } else if (response.error) this.error = this.$t("somethingWentWrong");
        });
      }
    },
  },
};
</script>
